import styled from 'styled-components';

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;

  .info {
  }

  .row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .col {
    flex: 8;
    font-size: 14px;
  }
  .col.header {
    flex: 4;
  }

  .hide {
    visibility: hidden;
  }
`;
